import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../css/AboutCollege.css';

const AboutCollege = () => {
  const [aboutData, setAboutData] = useState(null);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const res = await axios.get('https://college-c1-backend.onrender.com/api/admin/about-college');
        const data = res.data;

        // Replace backslashes with forward slashes for image URL
        if (data && data.photo) {
          data.photo = data.photo.replace(/\\/g, '/');
        }

        setAboutData(data);
      } catch (err) {
        console.error('Error fetching about college:', err);
      }
    };

    fetchAboutData();
  }, []);

  return (
    <section className="about-college">
      <div className="container h2">
        {aboutData ? (
          <>
            <h2>{aboutData.title}</h2>
            <div className="content">
              <img
                src={`https://college-c1-backend.onrender.com/${aboutData.photo}`}
                alt="S.N. Sinha College"
              />
              <div className="text">
                <p>{aboutData.description}</p>
                <p className="read-more">Read More</p>
              </div>
            </div>
          </>
        ) : (
          <p>Loading...</p>
        )}
      </div>
    </section>
  );
};

export default AboutCollege;
